<template>
    <div>
        <div id="pdfDom">
            <div style="height: 50px;"></div>
            <div id="pf1" class="pf w0" data-page-no="1">
                <div class="t pc pc1 w0 h0">
                    <img class="top_img" alt="" src="@/assets/tongji.png" />
                    <div class="t m0 x1 h1 y1 ff1 fs0 fc0 sc0 ls0 ws0">审批报告
                    </div>
                    <div class="t m0 x2 h2 y2 ff1 fs1 fc0 sc0 ls0 ws0">
                        报告编号：{{ strategyData.swift_number }}<span class="ff2"></span>
                    </div>
                    <div class="t m0 x2 h3 y3 ff1 fs1 fc0 sc0 ls0 ws0">
                        生成时间 ：{{ itemInfo.createTime }}<span class="fc6 sc0"></span>
                    </div>

                    <div style="height: 100px;">
                        <div class="t m0 xa hb y23 ff4 fs6 fc0 sc0 ls0 ws0"></div>
                        <div class="t m0 x12 hc y24 ff1 fs2 fc0 sc0 ls0 ws0">验证规则： <span class="fs7 fc2">{{
                              getScore(InfoVerification) }}</span>
                        </div>
                        <div class="t m0 x12 h7 y25 ff2 fs3 fc3 sc0 ls0 ws0">(MCP_BR0003360 / <span
                                class="ff1">预置_验证流程策略_001)</span></div>
                        <div class="t m0 x13 hb y23 ff4 fs6 fc0 sc0 ls0 ws0"></div>
                        <div class="t m0 x14 hc y24 ff1 fs2 fc0 sc0 ls0 ws0">反欺诈规则： <span class="fs7 fc2">{{
                                getScore(InfoVerification) }}</span>
                        </div>
                        <div class="t m0 x14 h7 y25 ff2 fs3 fc3 sc0 ls0 ws0">(STR_BR0006836 / <span
                                class="ff1">预置_贷前风险策略_001)</span></div>
                        <div class="t m0 xa hb y26 ff4 fs6 fc0 sc0 ls0 ws0"></div>
                        <div class="t m0 x12 hd y27 ff1 fs2 fc0 sc0 ls0 ws0">反欺诈评分： <span class="ff3 fs7 fc2">{{
                                scoreafrevoloan }} <span class="ff1">分</span></span></div>
                        <div class="t m0 x12 h6 y28 ff1 fs3 fc3 sc0 ls0 ws0">低风险 0-31，中风险 32-79 ，高风险 80-100</div>
                        <div class="t m0 x13 hb y26 ff4 fs6 fc0 sc0 ls0 ws0"></div>
                        <div class="t m0 x14 hd y27 ff1 fs2 fc0 sc0 ls0 ws0">信用评分： <span class="fs7 fc2">{{ scoreconsoff }} <span
                                    class="ff1">分</span></span></div>
                        <div class="t m0 x14 h6 y28 ff1 fs3 fc3 sc0 ls0 ws0">一般 300-650，良好 651-749 ，较好 750-1000</div>
                    </div>

                    <div class="bakImg">
                        <div class="jiben">
                            基本信息
                        </div>
                    </div>

                    <div style="display: flex;justify-content: space-between;">
                        <div class="jiben_kehu">姓名：{{ itemInfo.name }} </div>
                        <div class="jiben_kehu">手机号：{{ itemInfo.cell }}</div>
                        <div class="jiben_kehu">身份证号：{{ itemInfo.cardId }}</div>
                    </div>
                    <!-- <div style="display: flex;">
                        <div class="jiben_kehu">客户编号：1</div>
                    </div> -->
                </div>
                <div class="bakImg" style="margin-top: 290px;">
                    <div class="jiben">
                        要素核查
                    </div>
                </div>
                <div class="jiben_kehu">策略描述：使用姓名、手机号、身份证号、银行卡号等信息对被查询人进行信息核对</div>
                <div class="jiben_kehu">结论分析：
                    <span v-if="verificationData.InfoVerification?.final_decision == 'Reject'">
                        <span style="color: red;">
                            <span style="margin-right: 20px;" v-show="Number(item.weight) > 0"
                                v-for="item in verificationData.InfoVerification.hit_rules.rule_c_telcheck_s">{{
                                    item.name_rule }}</span>
                        </span>
                    </span>
                    <span class="t m0 x7 h6 y9 ff1 fs3 fc1 sc0 ls0 ws0"
                        v-if="verificationData.InfoVerification?.final_decision != 'Reject'">
                        <span>
                            验证通过
                        </span>
                    </span>
                </div>


                <div class="bakImg">
                    <div class="jiben">
                        运营商核验
                    </div>
                </div>
                <div class="jiben_kehu">策略描述：查询被查询人的运营商信息</div>
                <div class="jiben_kehu">结论分析：
                    <span v-if="verificationData.InfoVerification?.final_decision == 'Reject'">
                        <span style="color: red;">
                            <span style="margin-right: 20px;" v-show="Number(item.weight) > 0"
                                v-for="item in verificationData.InfoVerification.hit_rules.rule_c_telstatus">{{
                                    item.name_rule }}</span>
                        </span>
                    </span>
                    <span v-if="verificationData.InfoVerification?.final_decision != 'Reject'">
                        <span>
                            验证通过
                        </span>
                    </span>
                </div>

                <div class="bakImg">
                    <div class="jiben">
                        风险识别
                    </div>
                </div>
                <div class="jiben_kehu">策略描述：该产品类命中 <span style="color: red;">
                        {{ Object.keys(strategyData.Rule.hit_rules?.ruleexecutionpro ?? {}).length }}
                    </span>条高风险</div>
                <div class="jiben_kehu">结论分析：
                    <span v-if="strategyData.Rule.result?.final_decision == 'Reject'">
                        <span
                            style="color: red;width: 1800px;word-wrap: break-word;text-align: left;overflow-wrap: break-word">
                            <span style="margin-right: 40px;" v-show="Number(item.weight) > 0"
                                v-for="item in strategyData.Rule.hit_rules?.ruleexecutionpro ?? {}">{{
                                    item.name_rule }}</span>
                        </span>
                    </span>
                    <span v-if="strategyData.Rule.result?.final_decision != 'Reject'">
                        <span style="color:black">
                            验证通过
                        </span>
                    </span>
                </div>


                <div class="bakImg">
                    <div class="jiben">
                        要素核查产品 - 命中详情
                    </div>
                </div>
                <div class="jiben_kehu">注： 1. 数据覆盖全国范围，移动、联通、电信三家运营商数据。</div>
                <div class="table_con">
                    <el-table :data="TelCheck" style="width: 100%">
                        <el-table-column prop="date" label="校验项">
                        </el-table-column>
                        <el-table-column prop="phone" label="手机号运营商">
                            <template slot-scope="scope">
                                {{ dianXin(scope.row.phoe) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="result " label="校验结果">
                            <template slot-scope="scope">
                                {{ dianRes(scope.row.result) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>


                <div class="bakImg">
                    <div class="jiben">
                        运营商核验产品-命中详情
                    </div>
                </div>
                <div class="jiben_kehu">手机信息验证</div>
                <div class="table_con">
                    <el-table :data="TelPeriod" style="width: 100%">
                        <el-table-column prop="date" label="手机运营商类型">
                            <template slot-scope="scope">
                                {{ dianXin(scope.row.phone) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="phone" label="手机在网状态">
                            <template slot-scope="scope">
                                {{ zaiWang(scope.row.status) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="result " label="手机在网时长">
                            <template slot-scope="scope">
                                {{ dataChoe(scope.row.value) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="jiben_kehu">注： 1. ."手机在网状态"、"手机在网时长"数据覆盖全国范围，移动、联通、电信三家运营商数据。</div>
                <!-- <div class="jiben_kehu">身份证号手机号归属地</div>
                <div class="table_con">
                    <el-table :data="TelCheck" style="width: 100%">
                        <el-table-column prop="date" label="身份证号所属省">
                        </el-table-column>
                        <el-table-column prop="phone" label="身份证号所属市">
                            <template slot-scope="scope">
                                {{ dianXin(scope.row.phoe) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="result " label="手机所属省">
                            <template slot-scope="scope">
                                {{ dianRes(scope.row.result) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="result " label="手机所属城市">
                            <template slot-scope="scope">
                                {{ dianRes(scope.row.result) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="result " label="手机卡类型">
                            <template slot-scope="scope">
                                {{ dianRes(scope.row.result) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div> -->

                <div class="bakImg">
                    <div class="jiben">
                        风险识别产品-命中详情
                    </div>
                </div>
                <div class="jiben_kehu">法院被执行人-限高版 （命中失信被执行人）</div>
                <div class="table_con">
                    <el-table :default-expand-all="true" :data="executionLimitedShi" style="width: 100%">
                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                        <el-table-column prop="iname" width="50" label="名称">
                        </el-table-column>
                        <el-table-column width="50" prop="age" label="年龄">
                        </el-table-column>
                        <el-table-column width="50" prop="sexname" label="性别">
                        </el-table-column>
                        <el-table-column width="80" prop="casecode" label="案号">
                        </el-table-column>
                        <el-table-column prop="areaname" label="地域名称">
                        </el-table-column>
                        <el-table-column prop="regdate" label="立案时间">
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item label="执行法院">
                                        <span>{{ props.row.courtname }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="信号描述">
                                        <span>{{ props.row.signalDesc }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="信号等级">
                                        <span>{{ props.row.signalRating }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="下架标识">
                                        <span>{{ props.row.sign }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="发布时间">
                                        <span>{{ props.row.publishdate }}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="jiben_kehu">法院被执行人-限高版 (命中限高被执行人)</div>
                <div class="table_con">
                    <el-table :default-expand-all="true" :data="executionLimited" style="width: 100%">
                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                        <el-table-column prop="iname" width="50" label="名称">
                        </el-table-column>
                        <el-table-column width="50" prop="age" label="年龄">
                        </el-table-column>
                        <el-table-column width="50" prop="sexname" label="性别">
                        </el-table-column>
                        <el-table-column width="80" prop="casecode" label="案号">
                        </el-table-column>
                        <el-table-column prop="areaname" label="地域名称">
                        </el-table-column>
                        <el-table-column prop="regdate" label="立案时间">
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item label="执行法院">
                                        <span>{{ props.row.courtname }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="信号描述">
                                        <span>{{ props.row.signalDesc }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="信号等级">
                                        <span>{{ props.row.signalRating }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="下架标识">
                                        <span>{{ props.row.sign }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="发布时间">
                                        <span>{{ props.row.publishdate }}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- <div class="jiben_kehu">命中曝光台</div>
                <div class="table_con">
                    <el-table :data="TelCheck" style="width: 100%">
                        <el-table-column prop="date" label="身份证号所属省">
                        </el-table-column>
                        <el-table-column prop="phone" label="身份证号所属市">
                            <template slot-scope="scope">
                                {{ dianXin(scope.row.phoe) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="result " label="手机所属省">
                            <template slot-scope="scope">
                                {{ dianRes(scope.row.result) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="result " label="手机所属城市">
                            <template slot-scope="scope">
                                {{ dianRes(scope.row.result) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="result " label="手机卡类型">
                            <template slot-scope="scope">
                                {{ dianRes(scope.row.result) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div> -->

                <div class="bakImg">
                    <div class="jiben">
                        特殊名单验证
                    </div>
                </div>
                <div class="table_con">
                    <el-table :data="specialListC" style="width: 100%">
                        <el-table-column type="index" width="100" label="序号"></el-table-column>
                        <el-table-column prop="name" label="命中特殊名单">
                            <template slot-scope="scope">
                                {{ getSpecialList(scope.row.name) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="取值结果">
                            <template slot-scope="scope">
                                {{ getName(scope.row.name) == '' ? scope.row.value == "0" ? "命中" : "未命中" :
                                    scope.row.value }}
                                {{ getName(scope.row.name) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="jiben_kehu">法院被执行人-高级版 （命中失信被执行人）</div>
                <div class="table_con">
                    <el-table :default-expand-all="true" :data="ExecutionProShi" style="width: 100%">
                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                        <el-table-column prop="name" width="50" label="名称">
                        </el-table-column>
                        <el-table-column prop="time" width="60" label="立案日期">
                        </el-table-column>
                        <el-table-column prop="posttime" width="60" label="发布时间">
                        </el-table-column>
                        <el-table-column prop="casenum" width="80" label="案号">
                        </el-table-column>
                        <el-table-column prop="sign" width="70" label="下架标识">
                        </el-table-column>
                        <el-table-column prop="matchRatio" width="100" label="个人匹配度">
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item label="五级分类">
                                        <span>{{ props.row.eventLevel }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="执行法院">
                                        <span>{{ props.row.court }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="地址">
                                        <span>{{ props.row.address }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="依据单位">
                                        <span>{{ props.row.basecompany }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="履行情况">
                                        <span>{{ props.row.performance }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="义务">
                                        <span>{{ props.row.obligation }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="信号描述">
                                        <span>{{ props.row.signalDesc }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="信号等级">
                                        <span>{{ props.row.signalRating }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="具体情形">
                                        <span>{{ props.row.concretesituation }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="依据文号">
                                        <span>{{ props.row.base }}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="jiben_kehu">法院被执行人-高级版 （命中法院被执行人）</div>
                <div class="table_con">
                    <el-table :default-expand-all="true" :data="ExecutionPro" style="width: 100%">
                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                        <el-table-column prop="name" width="50" label="名称">
                        </el-table-column>
                        <el-table-column width="80" prop="casenum" label="案号">
                        </el-table-column>
                        <el-table-column prop="money" label="执行金额">
                        </el-table-column>
                        <el-table-column prop="matchRatio" label="个人匹配度">
                        </el-table-column>
                        <el-table-column prop="statute" label="案件状态">
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item label="立案日期">
                                        <span>{{ props.row.time }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="五级分类">
                                        <span>{{ props.row.eventLevel }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="执行法院">
                                        <span>{{ props.row.court }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="信号描述">
                                        <span>{{ props.row.signalDesc }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="信号等级">
                                        <span>{{ props.row.signalRating }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="下架标识">
                                        <span>{{ props.row.sign }}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="jiben_kehu">注：</div>
                <div class="jiben_kehu">1. 个人匹配度：取值0~1。值越大，表示匹配程度越高。</div>
                <div class="jiben_kehu">2. 五级分类：警告、负向、中性、正向、利好。在司法数据中只有警告、负向、中性三级。其中警告表示较高行政单位作出的判决，或金额较
                    大，或为刑事类案件等；负向表示一般案件，涉及金额较小，未造成严重后果；中性有可能没有金额判定。</div>

                <div class="bakImg">
                    <div class="jiben">
                        法院裁判文书
                    </div>
                </div>
                <div class="table_con">
                    <el-table :default-expand-all="true" :data="ExecutionJud" style="width: 100%">
                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                        <el-table-column prop="court" width="80" label="法院名称">
                        </el-table-column>
                        <el-table-column width="70" prop="courtRank" label="法院等级">
                            <template slot-scope="scope">
                                {{ scope.row.courtRank == 1 ? '最高人民法院' : scope.row.courtRank == 2 ? '高级人民法院' :
                                    scope.row.courtRank == 3 ? '中级人民法院' : '基层人民法院' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="caseCause" width="70" label="案由">
                        </el-table-column>
                        <el-table-column prop="trialProcedure" width="70" label="审理程序">
                        </el-table-column>
                        <el-table-column prop="eventLevel" width="70" label="五级分类">
                        </el-table-column>
                        <el-table-column prop="matchRatio" width="70" label="匹配度">
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <div>
                                    审结时间: {{ props.row.sortTimeString }}
                                </div>
                                <div style="margin-top: 10px;">
                                    案号: {{ props.row.caseNo }}
                                </div>
                                <div style="margin-top: 10px;">
                                    文书类型: {{ props.row.caseTypeS }}
                                </div>
                                <div style="margin-top: 10px;">
                                    内容: {{ props.row.body }}
                                </div>
                                <div style="margin-top: 10px;">
                                    判决结果: {{ props.row.judgeResult }}
                                </div>
                                <div style="margin-top: 10px;">
                                    依据: {{ props.row.foundation }}
                                </div>
                                <div style="margin-top: 10px;">
                                    <el-table :default-expand-all="true" border :data="props.row.parties"
                                        style="width: 80%;margin: 0 auto;">
                                        <el-table-column prop="pname" width="100" label="当事人名称"></el-table-column>
                                        <el-table-column prop="partyType" width="50" label="当事人类型">
                                        </el-table-column>
                                        <el-table-column width="80" prop="partyPosition" label="当事人立场">
                                        </el-table-column>
                                        <el-table-column prop="partyTitle" label="当事人称号">
                                        </el-table-column>
                                        <el-table-column prop="partyFee" width="60" label="判决金额">
                                        </el-table-column>
                                        <el-table-column prop="partyResult" width="50" label="结果">
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <!-- <el-form label-position="left" class="demo-table-expand">
                                    <el-form-item label="审结时间">
                                        <span>{{ props.row.sortTimeString }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="案号">
                                        <span>{{ props.row.caseNo }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="文书类型">
                                        <span>{{ props.row.caseTypeS }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="内容">
                                        <span>{{ props.row.body }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="判决结果">
                                        <span>{{ props.row.judgeResult }}</span>
                                    </el-form-item>
                                    <el-form-item label="依据">
                                        <span>{{ props.row.foundation }}</span>
                                    </el-form-item>
                        
                                </el-form> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>


                <div class="bakImg">
                    <div class="jiben">
                        法院信息详情-个人高级版
                    </div>
                </div>
                <div class="table_con">
                    <el-table :default-expand-all="true" :data="CourtDetailPro" style="width: 100%">
                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                        <el-table-column prop="dataType" width="50" label="查询项目">
                        </el-table-column>
                        <el-table-column width="80" prop="court" label="法院名称">
                        </el-table-column>
                        <el-table-column prop="caseNo" label="案号">
                        </el-table-column>
                        <el-table-column prop="matchRatio" label="匹配度">
                        </el-table-column>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-form label-position="left" inline class="demo-table-expand">
                                    <el-form-item label="立案时间">
                                        <span>{{ props.row.sortTimeString }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="被执行人姓名">
                                        <span>{{ props.row.pname }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="身份证号/组织机构代码">
                                        <span>{{ props.row.idcardNo }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="执行依据文号">
                                        <span>{{ props.row.yjCode }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="做出执行依据单位">
                                        <span>{{ props.row.yjdw }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="被执行人的履行情况">
                                        <span>{{ props.row.lxqk }}</span>
                                    </el-form-item>
                                    <br />
                                    <el-form-item label="内容概要">
                                        <span>{{ props.row.body }}</span>
                                    </el-form-item>
                                </el-form>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- <div class="bakImg">
                    <div class="jiben">
                        借贷评估产品 - 命中详情
                    </div>
                </div>
                <div class="jiben_kehu">借贷风险勘测</div>
                <div class="table_con">
                    <el-table :default-expand-all="true" :data="ApplyLoanStrFst" style="width: 100%">
                        <el-table-column prop="name" label="命中借贷风险勘测信息"></el-table-column>
                        <el-table-column prop="id_bank_in" label="按身份证号查询">
                        </el-table-column>
                        <el-table-column prop="id_nbank_in" label="按手机号查询">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="jiben_kehu">借贷风险勘测</div>
                <div class="table_con">
                    <el-table :default-expand-all="true" :data="applyLoanStr" style="width: 100%">
                        <el-table-column label="命中借贷风险勘测信息"></el-table-column>
                        <el-table-column label="身份证号查询的申请次数">
                        </el-table-column>
                        <el-table-column label="身份证号查询的申请机构数">
                        </el-table-column>
                        <el-table-column label="手机号查询的申请次数">
                        </el-table-column>
                        <el-table-column abel="手机号查询的申请机构数">
                        </el-table-column>
                    </el-table>
                </div> -->
                <!-- <div class="table_con">
                    <el-table :default-expand-all="true" :data="ApplyLoanStr" style="width: 100%">
                        <el-table-column label="命中借贷风险勘测信息"></el-table-column>
                        <el-table-column label="近7天">
                        </el-table-column>
                        <el-table-column label="近15天">
                        </el-table-column>
                        <el-table-column label="近1个月">
                        </el-table-column>
                        <el-table-column abel="近3个月">
                        </el-table-column>
                        <el-table-column label="近6个月">
                        </el-table-column>
                        <el-table-column label="近12个月">
                        </el-table-column>
                    </el-table>
                </div> -->

                <div class="bakImg">
                    <div class="jiben">
                        偿债压力指数
                    </div>
                </div>
                <div style="display: flex;">
                    <div class="jiben_kehu">偿债压力指数：{{ debtRepayStress }}</div>
                </div>
                <div>
                    <div class="jiben_kehu">注：</div>
                    <div class="jiben_kehu">1. 用户本人当前偿债压力指数的情况，取值为0 - 100，数值越大，压力越大。</div>
                    <div class="jiben_kehu">2. [0,69]压力较低;[70,85]压力较高;[86,100]压力极高。</div>
                </div>

                <div class="bakImg">
                    <div class="jiben">
                        团伙欺诈排查-通用版
                    </div>
                </div>
                <div style="display: flex; justify-content: space-between;">
                    <div class="jiben_kehu">风险等级：{{ fraudRelationG.name }}</div>
                    <div class="jiben_kehu">团伙规模：{{ fraudRelationG.value }}</div>
                </div>
                <div>
                    <div class="jiben_kehu">注：</div>
                    <div class="jiben_kehu">1. 风险等级取值区间为3-10，取值越大，风险越高。</div>
                    <div class="jiben_kehu">2. 团伙规模指同一风险等级对应群组规模的取值。</div>
                </div>

                <div class="bakImg">
                    <div class="jiben">
                        借贷意向验证
                    </div>
                </div>
                <div class="table_con">
                    <el-table :data="applyLoanStr" style="width: 100%;">
                        <el-table-column type="index" width="50" label="序号"></el-table-column>
                        <el-table-column prop="name" width="300" label="命中特殊名单">
                            <template slot-scope="scope">
                                {{ getApplyLoanStr(scope.row.name) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="value" label="取值结果">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <div style="display: flex; justify-content: center; margin-top: 20px;">
            <button style="background-color: #007bff;width: 500px; height: 50px;border-radius: 10px;margin: 0 auto;"
            @click="getPdf()">立即下载</button>
        </div>

    </div>
</template>

<script>
import { fengObj, nianName, ciName, mingName } from '@/utils/fengXian'
import { applyLoanStr } from '@/utils/applyLoanStr'
import flattenObject from '@/utils/flatten'
export default {
    name: 'PdfInfo',
    data() {
        return {
            scoreafrevoloan: '',
            InfoVerification: '',
            final_decision: '',
            final_weight: '',
            applyLoanStr: [],
            TelCheck: [{
                date: '身份证号、手机号、姓名',
                phoe: '1',
                result: '0'
            }],
            bad: [],
            itemInfo: {},
            verificationData: {
                InfoVerification: {

                }
            },
            strategyData: {
                Rule: {
                    hit_rules: {

                    }
                }
            },
            htmlTitle: 'pdf文件名',
            TelPeriod: [],
            specialListC: [],
            executionLimited: [],
            executionLimitedShi: [],
            ExecutionPro: [],
            ExecutionProShi: [],
            ExecutionJud: [],
            CourtDetailPro: [],
            ApplyLoanStrFst: [],
            debtRepayStress: null,
            fraudRelationG: {},
            scoreconsoff: '',
        }
    },
    mounted() {
        console.log(this.$route.query.id, 'this.$route.query');
        this.$axios.get(`/order/detail/${this.$route.query.id}`, {}).then(res => {
        // this.$axios.get(`/order/detail/2`, {}).then(res => {
            if (res.code == 200) {
                this.TelCheck = []
                this.TelPeriod = []
                this.strategyData = JSON.parse(res.data.strategyData)
                this.itemInfo = res.data
                this.verificationData = JSON.parse(res.data.verificationData)
                this.CourtDetailPro = this.verificationData.CourtDetailPro?.entryList
                let arr = this.verificationData.TelCheck_s
                this.TelPeriod.push({
                    value: this.verificationData.TelPeriod.data.value,
                    phone: this.verificationData.TelPeriod.operation,
                    status: this.verificationData.TelStatus.data.value,
                })
                console.log(this.verificationData, 'this.verificationData.ApplyLoanStr');

                let  id_bank_in = ''
                if(this.strategyData.ApplyLoanStr.fst){
                    if(this.strategyData.ApplyLoanStr.fst.id){
                        if(this.strategyData.ApplyLoanStr.fst.id.bank){
                            id_bank_in = this.strategyData.ApplyLoanStr.fst?.id?.bank?.inteday
                        }
                    }
                }

                let obj = {
                    name: '最近申请距今天数',
                    id_bank_in: this.strategyData.ApplyLoanStr.fst?.id?.bank?.inteday,
                    id_nbank_in: this.strategyData.ApplyLoanStr.fst?.id?.nbank?.inteday,
                }
                let obj2 = {
                    name: '最早申请距今天',
                    id_bank_in: this.strategyData.ApplyLoanStr.fst?.cell?.bank?.inteday,
                    id_nbank_in: this.strategyData.ApplyLoanStr.fst?.cell?.nbank?.inteday,
                }
                this.ApplyLoanStrFst.push(obj)
                this.ApplyLoanStrFst.push(obj2)
                let flatten = flattenObject(this.strategyData.ApplyLoanStr, "als")
                for (const key in flatten) {
                    this.applyLoanStr.push({
                        name: key,
                        value: flatten[key]
                    })
                }
                // 	最终决策结果
                this.final_decision = this.strategyData.RiskStrategy.final_decision
                // 最终规则评分
                this.final_weight = this.strategyData.Rule.result.final_weight
                // 验证规则
                this.InfoVerification = this.verificationData.InfoVerification.final_decision
                //偿债压力指数
                this.debtRepayStress = this.strategyData.DebtRepayStress.nodebtscore
                // 反诈评分
                this.scoreafrevoloan = this.strategyData.RiskStrategy.ScoreAf.scoreafconsoff
                // 信用评分
                this.scoreconsoff = this.strategyData.RiskStrategy.Score.scoreconsoff


                //团伙欺诈排查
                let objG = {
                    name: this.strategyData.FraudRelation_g.list_level,
                    value: this.strategyData.FraudRelation_g.group_num
                }
                this.fraudRelationG = objG

                for (const key in this.strategyData.ExecutionLimited) {
                    if (this.strategyData.ExecutionLimited[key].datatype.includes('限高被执行人')) {
                        this.executionLimited.push(this.strategyData.ExecutionLimited[key])
                    } else {
                        this.executionLimitedShi.push(this.strategyData.ExecutionLimited[key])
                    }
                }
                for (const key in this.strategyData.ExecutionJud) {
                    let partiesArray = [];
                    for (let i = 1; i <= 10; i++) {
                        const item = `p${i}`;
                        if (this.strategyData.ExecutionJud[key][item]) {
                            partiesArray.push(this.strategyData.ExecutionJud[key][item]);
                        }
                    }
                    console.log(partiesArray, `partiesArray for ${key}`);
                    this.strategyData.ExecutionJud[key].parties = partiesArray
                    this.ExecutionJud.push(this.strategyData.ExecutionJud[key]);
                }

                for (const key in this.strategyData.ExecutionPro) {
                    if (this.strategyData.ExecutionPro[key].datatype && this.strategyData.ExecutionPro[key].datatype.includes('失信被执行人')) {
                        this.ExecutionProShi.push(this.strategyData.ExecutionPro[key])
                    } else {
                        this.ExecutionPro.push(this.strategyData.ExecutionPro[key])
                    }
                }
                for (const key in this.strategyData.SpecialList_c.cell) {
                    let obj = {
                        name: "sl_cell_" + key,
                        value: this.strategyData.SpecialList_c.cell[key]
                    }
                    this.specialListC.push(obj)
                }
                for (const key in this.strategyData.SpecialList_c.id) {
                    let obj = {
                        name: "sl_id_" + key,
                        value: this.strategyData.SpecialList_c.id[key]
                    }
                    this.specialListC.push(obj)
                }
                // 解析手机三要素
                this.TelCheck.push(
                    {
                        date: '身份证号、手机号、姓名',
                        phoe: arr.operation,
                        result: arr.result,
                    })
                for (const key in this.strategyData.ExecutionPro) {
                    if (key.includes('bad')) {
                        this.bad.push(this.strategyData.ExecutionPro[key])
                    }
                }
                console.log(this.itemInfo);
            }
        })
        const pdfDom = document.getElementById('pdfDom');
        if (pdfDom) {
            pdfDom.addEventListener('scroll', this.handleScroll, { passive: true });
        }
    },
    methods: {
        getScore(val) {
            if (val == 'Reject') {
                return '建议拒绝'
            } else if (val == 'Review') {
                return '建议复议'
            } else if (val == 'Accept') {
                return '建议通过'
            } else {
                return ''
            }
        },
        getSpecialList(val) {
            return fengObj[val]
        },
        getApplyLoanStr(val) {
            return applyLoanStr[val]
        },
        getName(val) {
            if (mingName.includes(val)) {
                return '';
            }
            if (ciName.includes(val)) {
                return '次';
            }
            if (nianName.includes(val)) {
                return '年';
            }
            return false;
        },
        dataChoe(val) {
            switch (val) {
                case "1":
                    return '半年内';
                case "2":
                    return '一年内';
                case "3":
                    return '两年内';
                case "4":
                    return '两年以上';
                default:
                    return '';
            }
        },
        zaiWang(val) {
            switch (val) {
                case "1":
                    return '正常';
                case "2":
                    return '停机';
                case "3":
                    return '销号';
                case "4":
                    return '异常';
                default:
                    return '';
            }
        },
        dianRes(val) {
            switch (val) {
                case "0":
                    return '查无此号';
                case "1":
                    return '一致';
                case "2":
                    return '不一致';
                default:
                    return '';
            }
        },
        dianXin(val) {
            switch (val) {
                case "1":
                    return '电信';
                case "2":
                    return '联通';
                case "3":
                    return '移动';
                case "4":
                    return '其他(如 170 号段)';
            }
        },
        getEventLevel(value) {
            switch (value) {
                case -2:
                    return '警告';
                case -1:
                    return '负向';
                case 0:
                    return '中性';
                case 1:
                    return '正向';
                case 2:
                    return '利好';
                default:
                    return '';
            }
        },
        handleScroll(event) {
            // 处理滚动事件的逻辑
        }
    }
}
</script>

<style scoped>
.table_index {
    margin-top: 40px;
    width: 20px;
    margin-left: 10px;
    word-wrap: break-word;
    /* Ensures the text will wrap inside the element */
    word-break: break-all;
    font-size: 8px;
}

.aa {
    left: 0px;
    top: 0px;
    width: 532px;
    height: 64px;
    opacity: 1;
    border-radius: 2px;
    background: linear-gradient(90deg, rgba(35, 119, 132, 1) 0%, rgba(22, 91, 148, 0) 100%);
    border: 1px solid rgba(0, 0, 0, 1);
}

.demo-table-expand {
    font-size: 0;
}
::v-deep .el-table__row{
    height: 20px;
}
.demo-table-expand label {
    color: #99a9bf;
}

.demo-table-expand .el-form-iteml-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}

.el-form-item {
    height: 16px;
    margin-bottom: 0px;
}

::v-deep .el-form-item__label {
    font-size: 8px;
    /* float: none; */
}

::v-deep .el-form-item__content {
    font-size: 8px;
}

.table_con {
    margin-left: 35px;
    margin-right: 35px;
    margin-top: 10px;
}

.top_img {
    margin-top: 30px;
    margin-left: 30px;
    width: 50px;
    height: 50px;
}

.heng {
    width: 10px;
    height: 46px;
    background-color: #0cf;
}

.el-table {
    font-size: 8px
}

.table_index_bei {
    margin-top: 40px;
    width: 50px;
    margin-left: 15px;
    word-wrap: break-word;
    /* Ensures the text will wrap inside the element */
    word-break: break-all;
    font-size: 8px;
}

.table_index_fa {
    margin-top: 40px;
    width: 40px;
    margin-left: 10px;
    word-wrap: break-word;
    /* Ensures the text will wrap inside the element */
    word-break: break-all;
    font-size: 8px;
}

.table_index_miaoshu {
    margin-top: 10px;
    margin-left: 10px;
    word-wrap: break-word;
    /* Ensures the text will wrap inside the element */
    word-break: break-all;
    font-size: 8px;
    border-bottom: 1px solid #ccc;
    /* 添加底部边框 */
    padding-bottom: 5px;
    /* 可选，调整底部边距 */
}

.cell {
    word-wrap: break-word;
    /* Ensures the text will wrap inside the element */
    word-break: break-all;
    font-size: 10px;
}

.jiben {
    padding-top: 3px;
    /* padding-top: 5px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400; */
    font-size: 13px;
    /* color: #000000;
    line-height: 23rpx;
    text-align: left;
    font-style: normal;
    text-transform: none;
    background: none;  */
    margin-left: 15px;
    margin-top: 20px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 25.44px;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    vertical-align: top;
}

.jiben_kehu {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 8px;
    color: #000000;
    line-height: 23rpx;
    text-align: left;
    font-style: normal;
    text-transform: none;
    background: none;
    margin-left: 35px;
    margin-right: 35px;
    margin-top: 10px;
}

.bakImg {
    margin-left: 10px;
    height: 30px;
    background-image: url('@/assets/bakItem.png');
    background-repeat: no-repeat;
}
</style>